import service from './api.services';

const listar = async (filtro) => {
    const response = await service.get('/api/processo', {
        params: { ...filtro, pagina: filtro.pagina - 1 },
        hideLoading: true,
    });
    return response.data;
};

const listarPaginaInicialGO = async (filtro) => {
    const response = await service.get('/api/processo/pagina-inicial', {
        params: { ...filtro, pagina: filtro.pagina - 1 },
        hideLoading: true,
    });
    return response.data;
};

const listarPageValidacaoProposta = async (filtro) => {
    const response = await service.get('/api/processo/validacao-proposta', {
        params: { ...filtro, pagina: filtro.pagina - 1 },
        hideLoading: true,
    });
    return response.data;
};

const listarPageCaixaEntradaGO = async (filtro) => {
    const response = await service.get('/api/processo/caixa-entrada', {
        params: { ...filtro, pagina: filtro.pagina - 1 },
        hideLoading: true,
    });
    return response.data;
};

const listarPageDesvincular = async (filtro) => {
    const response = await service.get('/api/processo/list/desvincular', {
        params: { ...filtro, pagina: filtro.pagina - 1 },
        hideLoading: true,
    });
    return response.data;
};

const listarPageTermoCompromisso = async (filtro) => {
    const response = await service.get('/api/processo/termo-compromisso', {
        params: { ...filtro, pagina: filtro.pagina - 1 },
        hideLoading: true,
    });
    return response.data;
};

const listarPageConsultarProcessos = async (filtro) => {
    const response = await service.get('/api/processo/consultar-processos', {
        params: { ...filtro, pagina: filtro.pagina - 1 },
        hideLoading: true,
    });
    return response.data;
};

const listarPageReanalise = async (filtro) => {
    const response = await service.get('/api/processo/reanalise-proposta', {
        params: { ...filtro, pagina: filtro.pagina - 1 },
        hideLoading: true,
    });
    return response.data;
};

const listarMunicipiosDisponiveis = async () => {
    const response = await service.get('/api/processo/municipios');
    return response.data;
};

const vincular = async (idProcesso, dto) => {
    const response = await service.post(`/api/processo/${idProcesso}/vincular`, dto);
    return response.data;
};

const desvincular = async (idProcesso, dto) => {
    const response = await service.post(`/api/processo/${idProcesso}/desvincular`, dto);
    return response.data;
};
const downloadPrada = async (idProcesso) => {
    try {
        const response = await service.get(`/api/processo/download/prada/${idProcesso}`, {
            responseType: 'blob',
            validateStatus: status => true,
            hideGlobalError: true,
        });

        // Se erro, tentar converter blob para JSON (caso o backend envie JSON)
        if (response.status >= 400) {
            const contentType = response.headers['content-type'];
            if (contentType && contentType.includes('application/json')) {
                const text = await response.data.text();
                const json = JSON.parse(text);
                throw new Error(json.message || 'Erro ao baixar documento');
            }
            throw new Error('Erro desconhecido ao baixar documento');
        }

        return response;
    } catch (err) {
        throw err;
    }
};
const iniciarAnalise = async (idProcesso) => {
    const response = await service.post(`/api/processo/${idProcesso}/iniciar-analise`);
    return response.data;
};

const buscarPorId = async (idProcesso) => {
    const response = await service.get(`/api/processo/${idProcesso}`);
    return response.data;
};

const voltarEtapa = async (idProcesso) => {
    const response = await service.post(`/api/processo/${idProcesso}/voltar`);
    return response.data;
};

const buscarStatusEtapas = async (idProcesso) => {
    const response = await service.get(`/api/processo/etapaAtual/${idProcesso}`);
    return response.data;
};

const buscarEtapaResumo = async (idProcesso) => {
    const response = await service.get(`/api/processo/resumo/${idProcesso}`);
    return response.data;
};

const finalizarAvaliacaoTecnico = async (data) => {
    const response = await service.post('/api/processo/finalizar', data);
    return response.data;
};

const salvarValidacaoGO = async (data) => {
    const response = await service.post('/api/processo/validarResultadoAnalise', data);
    return response.data;
};

const getMinutaInformacoes = async (idProcesso) => {
    const response = await service.get(`/api/processo/resumo/minuta/${idProcesso}`);
    return response.data;
};

const downloadDocumento = async (caminho) => {
    const response = await service.get(`/api/processo/download?caminho=${caminho}`, {
        responseType: 'blob',
    });
    return response;
};

const downloadDocumentoCentral = async (idDocumento, idArquivo) => {
    const response = await service.get(`/api/central/documento/${idDocumento}/arquivo/${idArquivo}`, {
        responseType: 'blob',
    });
    return response;
};

const buscarInformacoesAnalise = async (idProcesso) => {
    const response = await service.get(`/api/processo/informacoes-analise/${idProcesso}`);
    return response.data;
};

const buscarHistoricoPorCodigoImovel = async (codigoImovel) => {
    const response = await service.get(`/api/processo/historico/${codigoImovel}`);
    return response.data;
};

const regerTermosPorCondicaoEEnviarEmailCompromissarioExterno = async (condicao) => {
    const response = await service.get(`/api/processo/regera-termos-e-envia-email/${condicao}`);
    return response;
};

const buscarAllAnaliseHistoricoPorIdProcesso = async (idProcesso) => {
    const response = await service.get(`/api/processo/buscar-all-analise-historico/${idProcesso}`);
    return response;
};

const downloadDemonstrativoSicar = async (codigoImovel) => {
    const response = await service.get(`/api/processo/download-demonstrativo/${codigoImovel}`, {
        responseType: 'blob',
    });
    return response;
};

const listarPorGerenteOperacional = async (idGerenteOperacional, codigoImovel) => {
    const url = `/api/processo/gerente-operacional/listar/processos/${idGerenteOperacional}`;

    const response = await service.get(url, {
        params: {
            codigoImovel: codigoImovel || null
        }
    });

    return response.data;
};

const alterarGerenteOperacionalProcesso = async (idGerenteAtual, idNovoGerente, idsProcessos) => {
    const url = '/api/processo/gerente-operacional/alterar';

    await service.post(url, null, {
        headers: {
            idGerenteAtual: idGerenteAtual, // ID do gerente atual
            idNovoGerente: idNovoGerente, // ID do novo gerente
            idsProcessos: idsProcessos || '', // IDs dos processos separados por vírgula
        },
    });
};

const listarGerentesOperacionaisEContagemProcessos = async (codigoImovel) => {
    const url = '/api/processo/gerente-operacional/disponiveis';

    const response = await service.get(url, {
        params: {
            codigoImovel: codigoImovel || null
        }
    });

    const gerentes = response.data.pageItems;

    return {
        gerentes,
        totalResults: response.data.totalResults,
    };
};

const consultarRetornoDocumentosRegularidade = async (idProcesso) => {
    const response = await service.get(`/api/processo/${idProcesso}/documentos-regularidade`);
    return response.data;
};

const alertNaolidos = async () => {
    const response = await service.get('/api/alerta/nao-lidos');
    return response;
};

const novasPropostasEnviadas = async () => {
    const id_tipo_alerta = 1; // Novas propostas enviadas
    const response = await service.get('/api/alerta/listar-alerta-por-tipo-e-municipio/' + id_tipo_alerta);
    return response;
};

const propostasAguardandoValidacao = async () => {
    const id_tipo_alerta = 2; // Propostas aguardando validação
    const response = await service.get('/api/alerta/listar-alerta-por-tipo-e-municipio/' + id_tipo_alerta);
    return response;
};

const termoAguardandoAssinatura = async () => {
    const id_tipo_alerta = 3; // Termos aguardando assinatura
    const response = await service.get('/api/alerta/listar-alerta-por-tipo-e-municipio/' + id_tipo_alerta);
    return response;
};

const termoAssinado = async () => {
    const id_tipo_alerta = 4; // Termos assinados
    const response = await service.get('/api/alerta/listar-alerta-por-tipo-e-municipio/' + id_tipo_alerta);
    return response;
};

const propostaEmAnalise = async () => {
    const id_tipo_alerta = 5; // Propostas em análise
    const response = await service.get('/api/alerta/listar-alerta-por-tipo-e-municipio/' + id_tipo_alerta);
    return response;
};

const imoveisAguardandoSuspensao = async () => {
    const id_tipo_alerta = 6; 
    const response = await service.get('/api/alerta/listar-alerta-por-tipo-e-municipio/' + id_tipo_alerta);
    return response;
};

const atualizarParaLido = async (idTipoAlerta) => {
    const response = await service.get('/api/alerta/atualizar-para-lido/' + idTipoAlerta);
    return response;
};

const listarPageExportXls = async (filtro) => {
    const response = await service.get('/api/processo/exportacao-xls', {
        params: { ...filtro, pagina: filtro.pagina - 1 },
        hideLoading: true,
    });
    return response.data;
};

const exportarRelatorio = async (filtro) => {
    const response = await service.get('/api/processo/exportar-relatorio', {
        params: { ...filtro, pagina: filtro.pagina - 1 },
        responseType: 'blob',
    });
    return response.data;
};

const exportarAreasRecomporByCodigoImovel = async (codigoImovel, areasSelecionadas) => {
    const response = await service.post(`/api/processo/exportar-shape/areas-recompor/${codigoImovel}`, 
        areasSelecionadas, 
        { responseType: 'blob'}
    );
    return response.data;
};

const gerarRelatorioAreasRecompor = async (filtro, email) => {
    const response = await service.post('/api/processo/gerar-shapes/areas-recompor', filtro, {
        params: { email },
        hideLoading: true,
    });
    
    return response.data;
};

const solicitarNovaAnalise = async (idProcesso, justificativa) => {
    const response = await service.post(`/api/processo/nova-analise/${idProcesso}`, null, {
        params: { justificativa },
        hideLoading: true,
    });
    
    return response.data;
};

export {
    listar,
    listarPageValidacaoProposta,
    listarPageCaixaEntradaGO,
    listarPageTermoCompromisso,
    listarPageConsultarProcessos,
    listarPageReanalise,
    listarMunicipiosDisponiveis,
    vincular,
    iniciarAnalise,
    buscarPorId,
    buscarEtapaResumo,
    voltarEtapa,
    downloadPrada,
    finalizarAvaliacaoTecnico,
    salvarValidacaoGO,
    buscarStatusEtapas,
    getMinutaInformacoes,
    downloadDocumento,
    downloadDocumentoCentral,
    buscarInformacoesAnalise,
    regerTermosPorCondicaoEEnviarEmailCompromissarioExterno,
    buscarAllAnaliseHistoricoPorIdProcesso,
    downloadDemonstrativoSicar,
    listarPorGerenteOperacional,
    alterarGerenteOperacionalProcesso,
    listarGerentesOperacionaisEContagemProcessos,
    listarPageDesvincular,
    desvincular,
    consultarRetornoDocumentosRegularidade,
    alertNaolidos,
    novasPropostasEnviadas,
    propostasAguardandoValidacao,
    termoAguardandoAssinatura,
    termoAssinado,
    propostaEmAnalise,
    listarPageExportXls,
    atualizarParaLido,
    listarPaginaInicialGO,
    exportarRelatorio,
    exportarAreasRecomporByCodigoImovel,
    gerarRelatorioAreasRecompor,
    solicitarNovaAnalise,
    buscarHistoricoPorCodigoImovel,
    imoveisAguardandoSuspensao
};
